import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PasswordComponent } from './password.component';

const COMPONENTS = [
	PasswordComponent
];

const MODULES = [
	CommonModule,
	FormsModule
];

@NgModule({
	declarations: [...COMPONENTS],
	imports: [...MODULES],
	exports: [...COMPONENTS]
})
export class PasswordModule { }
